var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWalletBgDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1370,
    height: 352,
    viewBox: "0 0 1370 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7864_2918)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1370,
    height: 352,
    fill: "#1D3B02"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1284.59 410.59C1269.8 400.412 1250.26 393 1244.06 376.153C1238.06 359.851 1239.18 335.696 1253.27 325.521C1271.44 312.385 1311.74 342.588 1319.59 321.576C1334.33 282.07 1284.4 236.902 1300.84 198.072C1311.19 173.624 1343.87 155.638 1363.67 173.334C1391.32 198.059 1378.74 262.951 1403.9 290.213C1420.05 307.701 1453.04 277.103 1474.36 287.674C1494.06 297.441 1504.37 321.154 1509.46 342.544C1514.68 364.513 1507.85 387.042 1503.25 409.151C1498.24 433.283 1502.86 467.095 1481.14 478.739C1456.23 492.091 1426.55 461.836 1398.5 465.301C1378.62 467.757 1365.43 503.8 1347.31 495.275C1325.18 484.864 1334.34 447.917 1319.79 428.266C1311.88 417.581 1295.54 418.127 1284.59 410.59Z",
    fill: "url(#paint0_linear_7864_2918)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.096 -128.164C119.482 -135.377 137.14 -148.344 155.5 -144.201C173.267 -140.192 193.881 -125.431 194.809 -107.242C196.007 -83.7585 146.459 -65.5093 160.478 -46.6317C186.837 -11.1381 255.047 -29.3382 279.845 7.26348C295.457 30.3087 292.658 69.3169 265.805 76.6488C228.283 86.8936 178.35 38.8388 140.019 45.4411C115.43 49.6765 123.551 96.1486 102.096 108.886C82.2744 120.654 55.5312 116.21 33.8084 108.495C11.4984 100.572 -4.43412 81.7205 -21.2691 65.0744C-39.6449 46.9046 -72.035 31.7042 -69.8995 5.95058C-67.4507 -23.5805 -23.9092 -32.4545 -10.9714 -59.1134C-1.80525 -78.0004 -26.0003 -110.158 -8.17127 -121.242C13.6016 -134.778 40.8928 -105.659 66.4799 -107.265C80.3924 -108.138 89.2209 -122.821 102.096 -128.164Z",
    fill: "url(#paint1_linear_7864_2918)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7864_2918",
    x1: 1464.86,
    y1: 489.396,
    x2: 1280.6,
    y2: 204.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABBAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7864_2918",
    x1: -70,
    y1: -14.447,
    x2: 285.349,
    y2: -14.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABBAAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7864_2918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1370,
    height: 352,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBgDark);
export default __webpack_public_path__ + "static/media/wallet-bg-dark.2bf5d6e8f177f44bf09ff16708dea4e3.svg";
export { ForwardRef as ReactComponent };